<template>
  <div>
    <!-- Show skeleton when loading -->
    <ContactDetailsSkeleton v-if="isLoading"/>

    <!-- Show actual content when loaded -->
    <PageLayout
      v-else
      :layout="'vertical'"
      :show-profile-header="true"
      :show-page-tabs="true"
      :show-breadcrumbs="false"
      :show-page-header="false"
      :customer="customer"
      :breadcrumb-items="breadcrumbItems"
      :tabs="pageTabs"
      :active-tab="activeTab"
      :entity-name="extractFullName(customer)"
      :entity-number="customer.number"
      :entity-address="customer.address"
      :about-text="customer.about"
      :profile-image-url="customer.profileImageUrl"
      :show-action-button="false"
      :show-profile-header-image-uploader="true"
      :locale="locale"
      @change-profile-image-clicked="onChangeProfileImageClicked"
    >
      <template #headerActions>
        <EmailContactButton :contact-id="customerId"/>
      </template>

      <ContactDetailsPageBody
        :customer="customer"
      />

      <ContactImageUploader ref="imageUploader" @contact-profile-image-selected="handleImageSelected"/>

      <button
        id="showContactProfileImageModal"
        data-toggle="modal"
        data-target="#contactProfileImageModal"
        hidden="hidden"
      />
    </PageLayout>
  </div>
</template>

<script>
import PageLayout from "../layouts/PageLayout.vue";
import contactService from "../../service/contact.service";
import {handleError, showSuccess, showWarning} from "../../utils/notification.utils";
import permissionService from "../../service/permission.service";
import ViewCustomerStatementButton from "../shared/ViewCustomerStatementButton.vue";
import ContactDetailsPageBody from "./ContactDetailsPageBody.vue";
import EmailContactButton from "../shared/EmailContactButton.vue";
import {extractFullName} from "../../utils/utils";
import ContactImageUploader from "./ContactImageUploader.vue";
import fileService from "../../service/file.service";
import ContactDetailsSkeleton from "./ContactDetailsSkeleton.vue";

export default {
  components: {
    EmailContactButton,
    ContactDetailsPageBody,
    ViewCustomerStatementButton,
    PageLayout,
    ContactImageUploader,
    ContactDetailsSkeleton
  },
  data() {
    return {
      isLoading: true,
      locale: this.$i18n.locale,
      customer: {},
      customerId: null,
      activeTab: 'contact-basic-details',
      pageTabs: [],
      breadcrumbItems: [
        {label: 'Home', to: '/dashboard'},
        {label: this.$t('sidebar.owners'), to: '/contacts'},
        {label: 'Profile', to: '/contacts/basic-details'},
      ],
      pagePermissions: [
        'CUSTOMER_READ'
      ]
    };
  },
  methods: {
    extractFullName,
    onChangeProfileImageClicked() {
      this.$refs.imageUploader.showModal();
    },
    handleImageSelected(imageData) {
      if (!imageData) return;
      const file = {
        fileName: 'profile_image_' + this.customerId + '.png',
        contentType: 'image/png',
        base64Content: imageData,
        folder: 'contact-profile-images',
        entityId: this.customer.id,
        entityType: 'CONTACT',
        fileType: 'CONTACT_PROFILE_IMAGE'
      };
      this.isLoading = true;
      fileService.uploadBase64File(localStorage.getItem("mid"), file)
        .then(response => {
          let success = response.data.code === 'SUCCESS';
          if (success) {
            this.retrieveCustomer(this.customerId)
          } else {
            showWarning(response.data.description || 'Failed to upload image');
          }
        })
        .catch(e => {
          handleError(e);
        })
        .finally(() => {
          this.isLoading = false;
          this.$refs.imageUploader.stopWebcam();
        });
    },
    retrieveCustomer(id) {
      this.isLoading = true;
      contactService.findById(localStorage.getItem("mid"), id)
        .then(response => {
          this.customer = response.data.data;
        })
        .catch(e => {
          handleError(e);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    deleteCustomer(customerId) {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, delete it!'
      }).then(result => {
        if (result.isConfirmed) {
          contactService.delete(localStorage.getItem("mid"), customerId)
            .then(response => {
              if (response.data.success) {
                showSuccess('Successfully deleted');
                this.$router.push('/customers');
              } else {
                showWarning(response.data.narrative);
              }
            })
            .catch(e => handleError(e));
        }
      });
    }
  },
  async mounted() {
    this.customerId = this.$route.params.id;

    if (!this.$store.state.auth.user) {
      await this.$router.push('/login');
      return;
    }

    this.pageTabs = await permissionService.getPageTabs('contact-details', this.pagePermissions, this.customerId, this.locale);
    this.retrieveCustomer(this.customerId);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ContactDetails/ContactDetailsPage.vue